export const ALLOWED_COUNTRIES = ["cz", "de", "en", "hu", "pl", "ro", "sk"]
